import { render, staticRenderFns } from "./FaqNavigation.vue?vue&type=template&id=1495f6a4&scoped=true&"
import script from "./FaqNavigation.vue?vue&type=script&lang=js&"
export * from "./FaqNavigation.vue?vue&type=script&lang=js&"
import style0 from "./FaqNavigation.vue?vue&type=style&index=0&id=1495f6a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1495f6a4",
  null
  
)

export default component.exports